import type { RocketDto, RocketRecord, StageDto } from '@trajectory/contracts';
import { createDocumentStore } from './createDocumentStore';

export const useRocketStore = createDocumentStore<RocketDto>();

/** See the matching `loadMissionRecord` in `missionStore.ts` for why a record must be stripped down to its DTO shape before being stored. */
export function loadRocketRecord(record: RocketRecord): void {
  const { projectId: _projectId, derivedFrom: _derivedFrom, createdAt: _createdAt, updatedAt: _updatedAt, version, ...document } = record;
  useRocketStore.getState().load(record.id, document, version);
}

export function updateStage(stageId: string, update: Partial<StageDto>): void {
  const { document, patch } = useRocketStore.getState();
  if (!document) return;
  patch({ stages: document.stages.map((stage) => (stage.id === stageId ? { ...stage, ...update } : stage)) });
}

export function addStage(stage: StageDto): void {
  const { document, patch } = useRocketStore.getState();
  if (!document) return;
  patch({ stages: [...document.stages, stage] });
}

export function removeStage(stageId: string): void {
  const { document, patch } = useRocketStore.getState();
  if (!document || document.stages.length <= 1) return;
  patch({ stages: document.stages.filter((stage) => stage.id !== stageId) });
}

export function moveStage(stageId: string, direction: -1 | 1): void {
  const { document, patch } = useRocketStore.getState();
  if (!document) return;
  const index = document.stages.findIndex((stage) => stage.id === stageId);
  const target = index + direction;
  if (index < 0 || target < 0 || target >= document.stages.length) return;
  const stages = [...document.stages];
  [stages[index], stages[target]] = [stages[target]!, stages[index]!];
  patch({ stages });
}
